import { useCallback } from "react";

export const useServerFilterBriefs = (
  { briefStore, uiStore, setBriefs, setPagination, searchTerm , i, type}
) => {
  const serverFilterBriefs = useCallback(
    async ( searchStr, lastId, navId, i, type) => {
      const strSch = searchStr ?? searchTerm;
      const SearchString = strSch?.toLowerCase() ?? "";

      let filteredProjects = [];
      let searchbar = document.getElementById("searchbar");
      if (searchbar) {
        searchbar.disabled = true;
        searchbar.focus();
      }
      uiStore.setLoading(true);
      try {
        filteredProjects = await briefStore.getBriefsByFilters(SearchString,lastId,navId, i,type);

        if (Object.keys(filteredProjects).includes("briefs") && Array.isArray(filteredProjects.briefs)) {
          setBriefs(filteredProjects.briefs);
          setPagination({
            currentPage: filteredProjects?.currentPage ?? 1,
            hasMore: filteredProjects?.hasMore ?? false,
            nextCursor: filteredProjects?.nextCursor ?? "",
            prevCursor: filteredProjects?.prevCursor ?? "",
            pageSize: filteredProjects?.pageSize ?? 8,
            totalPages: filteredProjects?.totalPages ?? 0,
            totalItems: filteredProjects?.totalBriefs ?? 0
          });
        } else {
          setBriefs([]);
        }
      } catch (error) {
        setBriefs([]);
      } finally {
        if (searchbar) {
          searchbar.disabled = false;
          searchbar.focus();
        }
        uiStore.setLoading(false);
      }
    },
    [searchTerm, briefStore, uiStore, setBriefs, setPagination, i, type]
  );
  return { serverFilterBriefs };
};
